import {mainnet, opBNB, opBNBTestnet, Chain} from 'wagmi/chains'
import {getDefaultConfig} from '@rainbow-me/rainbowkit'
import {
    metaMaskWallet,
    binanceWallet,
    okxWallet,
    bitgetWallet,
    oneInchWallet,
    walletConnectWallet,
    ledgerWallet,
} from '@rainbow-me/rainbowkit/wallets'

export const bsc: Chain = {
    id: 56,
    name: 'BNB Smart Chain',
    nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18,
    },
    rpcUrls: {
        default: {http: ['https://bsc-dataseed.bnbchain.org']},
        public: {http: ['https://bsc-dataseed.bnbchain.org']},
    },
    blockExplorers: {
        default: {name: 'BscScan', url: 'https://bscscan.com'},
    },
} satisfies Chain

export const bscTestnet: Chain = {
    id: 97,
    name: 'BNB Smart Chain Testnet',
    nativeCurrency: {
        name: 'BNB',
        symbol: 'tBNB',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://bsc-testnet-dataseed.bnbchain.org'],
        },
        public: {
            http: ['https://bsc-testnet-dataseed.bnbchain.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'BscScan Testnet',
            url: 'https://testnet.bscscan.com',
        },
    },
} satisfies Chain

export const config = getDefaultConfig({
    appName: 'League of Traders Web3',
    projectId: 'dc559c85aebe04b5d42d76a9d5823096',
    chains: [mainnet, bsc, bscTestnet, opBNB, opBNBTestnet],
    wallets: [
        {
            groupName: 'Recommended',
            wallets: [metaMaskWallet, binanceWallet, okxWallet, bitgetWallet, oneInchWallet],
        },
        {
            groupName: 'Others',
            wallets: [ledgerWallet, walletConnectWallet],
        },
    ],
    ssr: true, // If your dApp uses server side rendering (SSR)
})
